import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { compose } from 'recompose'
import { get } from 'lodash'
import {
    messages as messagesApi, activities as activityApi
} from 'redux/modules/api'
import {
  notification,
  modal
} from 'redux/modules/app'

import { permissions, routerAdapter } from 'helpers/decorators'
import { withRouter } from 'react-router'
import { mapSchema } from '../../../../models/messages'
import { getActiveRole } from '../../../../utils/token'
import { ROLES } from '../../../../constants/enums'


function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
        routerAdapter(),
        permissions(),
        withRouter,
        connect(
            state => ({
              messages: state.api.messages,
              user: state.auth.user
            }),
            {
              ...messagesApi,
                getActivityLogs: activityApi.getActivityLogs,
              notification,
              modal,
              push
            }
        )
    )

    class Messages extends Component {
      static propTypes = {
        messages: PropTypes.object.isRequired,
        getMessages: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        addMessage: PropTypes.func.isRequired,
        decoFilter: PropTypes.string,
        user: PropTypes.object,
        allowMessagesFilter: PropTypes.bool,
        setMessagesParams: PropTypes.func,
        commonLimit: PropTypes.number,
        activeOrganization: PropTypes.object,
        getActivityLogs: PropTypes.func.isRequired
      }

      constructor(props) {
        super(props)
        this.key = uuid.v1()
      }

      state = {
          allowMessagesFilter: true
      }

        static defaultProps = {
            allowMessagesFilter: true,
            params: {}
        }

      componentDidMount() {
          const { commonLimit, setMessagesParams } = this.props

          if (config.useCommonLimit && commonLimit) {
              setMessagesParams({ limit: commonLimit })
          }
      }

        componentWillMount() {
            this.handleDisableFilter()
        }

        componentWillReceiveProps(nextProps) {
            const { messages } = this.props

            const { filter, limit, offset, sort, invalidate, settings } = nextProps.messages

            if (
                messages.filter !== filter ||
                messages.limit !== limit ||
                messages.offset !== offset ||
                messages.sort !== sort ||
                messages.invalidate !== invalidate ||
                messages.settings !== settings
            ) {
                config.list && this.handleGetMessages(nextProps.messages, this.handleGetBaseFilter())
            }
        }

        handleDisableFilter = () => {
            if (getActiveRole(this.props.activeOrganization) !== ROLES.LEADER.u) {
                this.setState({
                    allowMessagesFilter: false
                })
            }
        }

     handleGetMessages = (params, baseFilter, { praiseOnly, newOnly } = {}) => {
         const settings = get(params, 'settings')

         this.props.getMessages(params, baseFilter, settings, { praiseOnly: praiseOnly || config.praiseOnly, newOnly: newOnly || config.newOnly })
     }

     handleGetBaseFilter = () => {
            const { decoFilter, user } = this.props

            const allowMessagesFilter = this.state.allowMessagesFilter

            switch (allowMessagesFilter && (decoFilter || config.filter)) {
                case 'awardLeaderMessages':
                    return `author.id=${get(user, 'personId')}`
                case 'awardUnitMessages':
                    return `participantPerson.awards.organization.id=${get(this.props.activeOrganization, 'id')}`
                case 'organizationMessages':
                    return `participantPerson.awards.organization.flatHierarchy.parentOrganization.id=${get(this.props.activeOrganization, 'id')}`
                default:
                    return ''
            }
        }

      handleAddMessage = data => {
        this.props.addMessage(mapSchema(data)).then(() => {
            this.props.getActivityLogs(get(data, 'activityId'))
            this.props.notification('Message was successfully added.', {
              status: 'success',
              intlKey: 'notification.message_added'
            })
            this.props.modal(null)
        }
        ).catch(this.handleError)
      }

      handleError = ({ body }) =>
          this.props.notification(body && body.userMessage, 'error')


      render() {
        return (
            <ComposedComponent
                key={this.key}
                {...this.props}
                addMessage={this.handleAddMessage}
            />
        )
      }
    }
    return enhance(Messages)
  }
}

export default decorator
